/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
import { BrowserRouter } from "react-router-dom";
import { useCallback, useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import RoutesWrp from "./routes";
import ModalContainer from "./components/modal_popup";

import "./App.css";
import {
  CandidatePipelineActions,
  RolesAndAccessActions,
  notiDetailsActions,
  setShowMetaImageAction,
} from "./redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAdminDetailsByID,
  GetAssignFb,
  GetCanidateRetention,
  GetNotificationDetail,
  GetCallRemainderInterview,
  GetRolesAndAccess,
} from "./apiServices";
import GetNotificationComponent from "./components/notiDetailTemplate";

import DetailsPopups from "./components/Details_popups";

import AdminAccess from "./pages/AdminDetails/accessControl";
import Alert_popup from "./components/Alert_popup";
import { decryptedAdminID, formatDated } from "./utility";
import { io } from "socket.io-client";
import ToastComponent from "./components/Toast_Alert";
import LeadGenerationPipeline from "./pages/pipelines/candidatePipeline/components/leadGenerationPipeline";
import CallRemainder_Alert from "./components/CallRemainder_Alert";
import NotificationSound from "../src/assets/audio/best-notification.mp3";

export const clevertap_id = process.env.REACT_APP_CleverTap_id;
// console.log(clevertap_id);

export const profileBaseUrl =
  process.env.REACT_APP_CANDIDATE_REGISTARTION_BASE_URL;

export const base_url = process.env.REACT_APP_BASE_URL_ADMIN;
export const base_url_taizo = process.env.REACT_APP_BASE_URL;
export const base_url_node = process.env.REACT_APP_NODE_BASE_URL;
export const baseurl_node = process.env.REACT_APP_BASE_URL_NODE;
export const interview_channeltype =
  process.env.REACT_APP_INTERVIEW_SCHEDULE_channelType;
export const interview_channelid =
  process.env.REACT_APP_INTERVIEW_SCHEDULE_channelId;
// console.log(base_url_taizo);
// console.log(base_url);
// console.log(interview_channeltype);
// console.log(interview_channelid);

export const webConsoleBaseUrl =
  process.env.REACT_APP_EMPLOYER_CONSOLE_BASE_URL;

function App() {
  const Dispatch = useDispatch();
  let adminID = decryptedAdminID();
  console.log(adminID, "admin id login");
  let adminIDNumber = parseInt(adminID, 10);
  const socketRef = useRef();
  const [showmetaImage, setShowMetaImage] = useState(false);
  const [fromFbMetaLeadAd, setFromFbMetaLeadAd] = useState(false);
  const [showToastCall, setShowToastCall] = useState(false);
  const [isAvailable, setisAvailable] = useState(false);
  const [candidateRetentionData, setCandidateRetentionData] = useState(null);
  const [showRetentionModal, setShowRetentionModal] = useState(false); // State to control modal visibility
  const [showToast, setShowToast] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [notificationData, setNotificationData] = useState({});

  const candidateRetentionsFilter = useSelector(
    (state) => state.CandidateRetentionDetails.retentionsFilter
  );
  const showNotiData = useSelector(
    (state) => state.notifications.showNotiDetails
  );
  const notificationId = useSelector((state) => state.notifications.notiId);

  const adminAccess = useSelector((state) => state.RolesAndAccessDetails);
  let showImageMeta = useSelector(
    (state) => state.notificationmetaimage.showMetaImage
  );

  useEffect(() => {
    // console.log(adminAccess, "adminAccess------------------------------");
  }, [adminAccess]);

  //
  //   let alertSound = new Audio(NotificationSound);
  //   const socket = io(baseurl_node);
  //   socket.on("connect", () => {
  //     console.log("Connected to WebSocket server", adminIDNumber);
  //     socket.emit("register-client", adminIDNumber);

  //     // alert(adminIDNumber);
  //   });
  //   socket.on("timeline-notification", (data) => {
  //     // alert("Test connetced");
  //     Dispatch(CandidatePipelineActions.setMemberNotify(true));
  //     localStorage.setItem("receivedData", true);
  //     console.log("Received Data:", data);
  //     alertSound
  //       .play()
  //       .catch((err) => console.error("Error playing sound:", err));
  //   });

  //   return () => {
  //     socket.off("timeline-notification");
  //     alertSound.pause();
  //     alertSound.currentTime = 0;
  //   };
  // }, []);

  useEffect(() => {
    // Connect to the server
    const socket = io(baseurl_node);

    socket.on("connect", () => {
      // console.log("Connected to the server");
      // alert("Connected");
      // setShowToast(true);
      socket.emit("register-client", adminIDNumber);
    });


    socket.on("ai-call-received", (data) => {
      console.log("New AI Call Received:", data);
      // alert("New AI Call Received");
      Dispatch(notiDetailsActions.setShowReddot(true));
    });

    // // Listen for events from the server
    // socket.on("new-notification", (data) => {
    //   console.log("Message from server:", data);
    //   // alert("Testing socket");
    //   setShowToast(true);

    //   setTimeout(() => {
    //     setShowToast(false);
    //   }, 10000);
    // });

    // socket.on("new-meta-lead", (data) => {
    //   console.log("Received new-meta-lead event:", data);
    //   if (data.message === "You have a new meta lead") {
    //     console.log("gg");
    //     Dispatch(setShowMetaImageAction.setShowMetaImage(true));
    //     return;
    //   }
    //   Dispatch(setShowMetaImageAction.setShowMetaImage(false));

    //   // Hide the download icon after 3 seconds
    //   // setTimeout(() => {
    //   //   Dispatch(setShowMetaImageAction.setShowMetaImage(false));
    //   // }, 3000);
    // });

    // socket.on("new-meta-lead", (data) => {
    //   console.log("Received new-meta-lead event:", data);

    //   if (data.message === "You have a new meta lead") {
    //     Dispatch(setShowMetaImageAction.setShowMetaImage(true));

    //     // Hide the download icon after 3 seconds
    //     setTimeout(() => {
    //       Dispatch(setShowMetaImageAction.setShowMetaImage(false));
    //     }, 10000);
    //   } else {
    //     Dispatch(setShowMetaImageAction.setShowMetaImage(false));
    //   }
    // });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (adminID != null) {
      GetRolesAndAccess().then((res) => {
        let roleName = res.role_name;
        let accessName = res.access_names;
        Dispatch(
          RolesAndAccessActions.setRoleAndAccess({
            roleName: roleName,
            accessNames: accessName,
          })
        );
      });
    }
  }, [adminID]);

  const notificationDetail = useSelector(
    (state) => state.notifications.notificationDetail
  );

  useEffect(() => {
    GetNotificationDetail(notificationId)
      .then((data) => {
        if (data && data.data !== undefined) {
          // console.log(data, "notiDetailsActions");
          Dispatch(notiDetailsActions.setNotiDetail(data.data));
        } else {
          console.error("Invalid data structure or missing 'data' property");
        }
      })
      .catch((error) => {
        console.error("Error in API call:", error);
      });
  }, [showNotiData]);

  // const fetchData = useCallback(async () => {
  //   let data = await GetAssignFb();
  //   if (data.message === "Multiple leads found.") {
  //     setFromFbMetaLeadAd(true);
  //     // console.log("message lead add true");
  //   } else {
  //     setFromFbMetaLeadAd(false);
  //     // console.log("message lead add false");
  //   }
  // }, []);

  // const CandidateRententionDataFetch = useCallback(async () => {
  //   let data = await GetCanidateRetention(candidateRetentionsFilter);
  //   const today = new Date();
  //   const todayFormatted = formatDated(today);
  //   const pastWeekData = data.data.filter((item) => {
  //     const retentionDate = new Date(item.retention.date);
  //     const date = formatDated(retentionDate);

  //     return date < todayFormatted;
  //   });
  //   setCandidateRetentionData(pastWeekData);
  //   setShowRetentionModal(true); // Show the modal when data is fetched
  //   // console.log(data.data, "message lead data");
  // }, [candidateRetentionsFilter]);

  const isWithinTimeRange = (startHour, startMinute, endHour, endMinute) => {
    const now = new Date();
    const start = new Date();
    const end = new Date();
    start.setHours(startHour, startMinute, 0, 0);
    end.setHours(endHour, endMinute, 0, 0);
    return now >= start && now <= end;
  };

  const fetchCallRemainderData = async () => {
    try {
      if (adminID != null) {
        const today = new Date().toISOString().split("T")[0];
        const data = await GetCallRemainderInterview(adminID, today);
        console.log("API Response:", data);

        const hasTodayReminder = data.data.some(
          (item) => item.callRemainderDate === today
        );

        if (hasTodayReminder) {
          setShowToastCall(true); // Show toast if a match is found
        } else {
          setShowToastCall(false); // Ensure no toast if no match is found
        }
      }
    } catch (error) {
      console.error("Error fetching call remainder data:", error);
    }
  };

  useEffect(() => {
    const executeFetch = async () => {
      if (isWithinTimeRange(9, 0, 19, 0)) {
        await fetchCallRemainderData();
      } else {
        console.log("Outside business hours, skipping fetchCallRemainderData.");
      }
    };

    executeFetch();

    const interval = setInterval(() => {
      executeFetch();
    }, 7200000); // 2 hrs

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (adminID != null) {
      GetAdminDetailsByID(adminID).then((data) => {
        console.log(data, "details");
        localStorage.setItem("teamLeader", data.teamLeader);
        localStorage.setItem("teamLeaderId", data.admin.id);
        localStorage.setItem("adminuserName", data.admin.userName);
      });
    }
  }, [adminID]);
  // const checkAdminDetails = useCallback(async () => {
  //   try {
  //     const data = await GetAdminDetailsByID(adminID);
  //     // console.log(data, "GetAdminDetailsByID");

  //     if (data && data.admin) {
  //       setisAvailable(data.admin.isAvailable);
  //     } else {
  //       // console.warn("admin data is undefined");
  //       setisAvailable(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching admin details:", error);
  //     // Handle the error case
  //     setisAvailable(false);
  //   }
  // }, [adminID]);

  // useEffect(() => {
  //   const fetchDataAndCheckAdminDetails = async () => {
  //     await fetchData();
  //     await checkAdminDetails();
  //   };

  //   fetchDataAndCheckAdminDetails();
  //   const intervalId = setInterval(fetchDataAndCheckAdminDetails, 10000);

  //   // Clear interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, [fetchData, checkAdminDetails]);

  return (
    <>
      <div className="">
        <div>
          <AdminAccess />
          <BrowserRouter>
            <RoutesWrp />
          </BrowserRouter>
        </div>
      </div>
      <div className="alertpopup">
        {/* {fromFbMetaLeadAd && isAvailable && (
          <>
            <Alert_popup />
          </>
        )} */}

        {showImageMeta && (
          <>
            <Alert_popup />
          </>
        )}
      </div>
      {/* <div className="canretentionPopup">
        {showRetentionModal && (
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div className="d-flex align-items-center justify-content-end">
                    <div
                      className="mb-2 btn btn-danger"
                      onClick={() => setShowRetentionModal(false)} // Close the modal on click
                    >
                      <AiOutlineClose />
                    </div>
                  </div>
                  <CanRetentionAlert data={candidateRetentionData} />
                </>
              }
            />
          </MyModal>
        )}
      </div> */}
      <div>
        <ToastComponent triggerToast={showToast} />
      </div>

      <div>
        <>
          {showToastCall && (
            <>
              <CallRemainder_Alert
                triggerToast={showToastCall}
                onClose={() => {
                  setShowToastCall(false);
                  setIsAlertOpen(false); // Mark the alert as closed
                }}
                onOpen={() => setIsAlertOpen(true)}
              />
            </>
          )}
        </>
      </div>
      <div className="popUp_container">
        <div className={`${!showNotiData ? "d-none" : ""}`}>
          <ModalContainer
            childComponent={
              <GetNotificationComponent
                notificationDetail={notificationDetail}
              />
            }
          />
        </div>
        <div>
          {/* common details popup */}
          <DetailsPopups />
        </div>
      </div>
    </>
  );
}

export default App;
